import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "@/api";
import { Gavel, X } from "lucide-react";

/** Rappel discret tant que des CGV / CGU restent à accepter (chef & salarié). */
export function LegalPendingBanner({ portal }) {
  const [pending, setPending] = useState([]);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("pag_legal_banner_hidden") === "1");
  const { pathname } = useLocation();
  const target = `/${portal}/legal`;

  useEffect(() => {
    api.get("/legal/status").then((r) => setPending((r.data?.documents || []).filter((d) => d.needs_acceptance))).catch(() => setPending([]));
  }, [pathname]);

  if (hidden || !pending.length || pathname.startsWith(target)) return null;
  return (
    <div className="mx-6 lg:mx-10 mt-4 border border-[#FFD700] bg-[#FFFBEB] px-4 py-2.5 flex items-center gap-3 text-xs" data-testid="legal-pending-reminder">
      <Gavel className="h-4 w-4 text-[#B45309] shrink-0" />
      <span className="flex-1"><b>{pending.length === 1 ? "Un document légal" : `${pending.length} documents légaux`} à accepter</b> — {pending.map((d) => `${d.title} (v${d.version})`).join(", ")}.</span>
      <Link to={`${target}?doc=${pending[0].key}`} data-testid="legal-pending-reminder-link" className="font-bold uppercase tracking-wider text-[10px] px-3 py-1.5 bg-[#0A0A0A] text-white hover:bg-[#002FA7]">Lire et accepter</Link>
      <button type="button" onClick={() => { sessionStorage.setItem("pag_legal_banner_hidden", "1"); setHidden(true); }} data-testid="legal-pending-reminder-dismiss" className="text-[#868E96] hover:text-[#0A0A0A]" aria-label="Masquer"><X className="h-4 w-4" /></button>
    </div>
  );
}
